export default __webpack_public_path__ + "static/media/google.85bb28c0.svg";